<script setup lang="ts">
import { Sale } from '@caks/shared/types/types.api'
import { ProfileSaleItem } from '.'
import { CommonTitle } from '~/components/common'
import { getSales } from '@caks/shared/api/user.route'
import { useAccountStore } from '@caks/shared/store/store.account'

const store = useAccountStore()

const sales = ref<Sale[]>([])
const filtredSales = computed<Sale[]>(() => {
  if (store.promo?.id && sales.value) {
    return sales.value.filter((el) => {
      return el.id !== store.promo?.id
    })
  }

  return sales.value || []
})

onMounted(async () => {
  const { data } = await getSales()

  sales.value = data
})
</script>

<template>
  <div class="sales">
    <common-title title="Мои акции" />
    <ul class="sales__list">
      <transition-group name="list">
        <profile-sale-item v-for="sale in filtredSales" :key="sale.id" :sale="sale" />
      </transition-group>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.sales {
  display: flex;
  flex-direction: column;
  gap: 32px;

  &__list {
    display: flex;
    gap: 32px;
    overflow-x: auto;
    padding: 0 0 20px 10px;
    margin-left: -10px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $ui-gray-2;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $sub-text;
      border-radius: 10px;
      border: 2px solid $ui-gray-2;
    }
  }
}

.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-leave-active {
  position: absolute;
  top: 0;
  left: 50%;
}
</style>
